"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceYoutubeCookieEmbeds = void 0;
const YT_REGEX = /youtube\.com/gi;
const NO_COOKIE_HOST = 'youtube-nocookie.com';
const isReactPlayerSourceProps = (url) => {
    return Boolean(url && typeof url !== 'string' && url.src);
};
/**
 * Modifies the possible the url prop values of ReactPlayer to replace youtube.com embeds
 * @param url
 * @returns
 */
const replaceYoutubeCookieEmbeds = (url) => {
    let videoUrl = url;
    if (videoUrl) {
        if (typeof videoUrl === 'string') {
            //replace for simple string case
            videoUrl = videoUrl.replace(YT_REGEX, NO_COOKIE_HOST);
        }
        else if (Array.isArray(videoUrl) && videoUrl.length) {
            //replace for string[] or ReactPlayerSourceProps[] case
            videoUrl = videoUrl.map((vUrl) => {
                if (isReactPlayerSourceProps(vUrl)) {
                    vUrl.src = vUrl.src.replace(YT_REGEX, NO_COOKIE_HOST);
                    return vUrl;
                }
                return vUrl.replace(YT_REGEX, NO_COOKIE_HOST);
            });
        }
        // ignore MediaStream case since it can't be an embed
    }
    return videoUrl;
};
exports.replaceYoutubeCookieEmbeds = replaceYoutubeCookieEmbeds;
//# sourceMappingURL=videoUtils.js.map